<template>
  <v-card 
    :color="headersColor" 
    class="backgroundCard" 
    elevation="12"
  >
    <v-icon 
      :icon="headersIcon" 
      size="20"
      class="headerIcon" 
    />
    <span class="headerText">{{ headersTitle }}</span>
  </v-card>
</template>

<script>
export default {
  props: {
    headersTitle: { type: String, default: 'Platzbuchung' },
    headersIcon:  { type: String, default: 'mdi-clipboard-text' },
    headersColor: { type: String, default: 'surface'}
  },
}
</script>

<style scoped>
.backgroundCard {
    display: inline-flex;          /* passt sich dem Inhalt an */
    align-items: center;           /* Icon + Text vertikal mittig */
    gap: 1rem;                     /* Abstand zwischen Icon & Text */
    padding: 0.25rem 0.5rem;       /* etwas Innenabstand */
    width: auto;                   /* nicht strecken */
    max-width: max-content;        /* nur so breit wie der Inhalt */
    white-space: nowrap;           /* bleibt EINZEILIG */
    border-radius: 8px;
}
.headerIcon {
  color: rgb(var(--v-theme-on-surface));
}
.headerText {
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
}

</style>
